import { createStore, applyMiddleware, compose } from "redux";
import thunk from "redux-thunk";
import rootReducer from "./redux/reducers/rootReducer";
import { createLogger } from "redux-logger";
import throttle from 'lodash.throttle';
import { APP_STATE_KEY } from "./App.config";

const logger = createLogger({
  // ...options
});

const configureStore = (initialState = {}) => {

  const loadState = () => {
    try {
      const serializedState = localStorage.getItem(APP_STATE_KEY);
      if (serializedState === null) {
        return undefined;
      }
      return JSON.parse(serializedState);
    } catch (err) {
      return undefined;
    }
  }

  const saveState = (state) => {
    try {
      const serializedState = JSON.stringify(state);
      localStorage.setItem(APP_STATE_KEY, serializedState);
    } catch (err) {
      //Ignore write errors
    }
  }

  const persistedState = loadState();

  const composeEnhancers =
    (process.env.REACT_APP_STAGE === "local" &&
      typeof window !== "undefined" &&
      window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__) ||
    compose;
  let enhancer = undefined;

  if (process.env.REACT_APP_STAGE === "local") {
    enhancer = composeEnhancers(applyMiddleware(thunk, logger));
  } else {
    enhancer = composeEnhancers(applyMiddleware(thunk));
  }

  const store = createStore(rootReducer, persistedState, enhancer);

  store.subscribe(throttle(() => {
    saveState({
      profileReducer: store.getState().profileReducer,
    });
  }, 1000));

  // if (module.hot) {
  //   // Enable Webpack hot module replacement for reducers
  //   module.hot.accept('../reducers', () => {
  //     /* eslint-disable */
  //     const nextRootReducer = require('../reducers/index');
  //     /* eslint-enable */
  //     store.replaceReducer(nextRootReducer);
  //   });
  //}

  return store;
}

export default configureStore;
